export default "__VITE_ASSET__c378846e__"